import styled, { css } from 'styled-components'
import { Link } from "react-router-dom";

export const StyledLink = styled(Link)`
   text-decoration: none;
`
///////////// Drawer Link //////////////

const activeDrawerLink=({ $isActive }) => {
    if ($isActive) {
        return css`
        background-color:rgba(0, 0, 0, 0.04);
        `
    }
}
export const StyledDrawerLink = styled(Link)`
   text-decoration: none;
   display:flex;
   align-items:center;
   width:100%;
   ${activeDrawerLink}
`;

